<template>
  <v-navigation-drawer
    id="default-drawer"
    v-model="drawer"
    :dark="dark"
    :right="$vuetify.rtl"
    :src="drawerImage ? image : ''"
    :mini-variant.sync="mini"
    mini-variant-width="80"
    app
    width="260"
  >
    <template v-if="drawerImage" #img="props">
      <v-img :key="image" :gradient="gradient" v-bind="props" />
    </template>

    <div class="px-2">
      <default-drawer-header />
      <p v-if="userProfile" style="color: white" class="my-0 ml-2">
        {{ userProfile.firstName }}
      </p>
      <small
        style="color: white"
        class="my-0 ml-2"
        v-if="userProfile && userProfile.departmentName"
        >{{ userProfile.departmentName.substring(0, 30) }}</small
      >
      <p
        style="color: white; font-size: 9pt"
        class="my-0 ml-2"
        v-if="userProfile && userProfile.email"
      >
        {{ userProfile.email }}, {{ userProfile.roleName }}
      </p>
      <v-divider class="mx-3 mb-2" />
      <default-list :items="selectedItems" />
    </div>

    <template #append>
      <div class="pa-4 text-center">
        <v-dialog v-model="dialogIntro" max-width="40%" scrollable>
          <template v-slot:activator="{ on, attrs }">
            <app-btn
              v-if="userProfile != null"
              class="text-none mb-4"
              color="white"
              small
              text
              v-bind="attrs"
              v-on="on"
            >
              {{ userProfile.firstName }} ({{ userProfile.role }})
            </app-btn>
          </template>
          <v-card>
            <v-card-title class="headline"> Танилцуулга</v-card-title>
            <v-card-text>
              <v-card-text>
                AAAAdolor amet eget, elit nullam. Aliquam leo phasellus aliquam
                curabitur metus a, nulla justo mattis duis interdum vel, mollis
                vitae et id, vestibulum erat ridiculus sit pulvinar justo sed.
                Vehicula convallis, et nulla wisi, amet vestibulum risus, quam
                ac egestas. Et vitae, nulla gravida erat scelerisque nullam nunc
                rutrum elit, ultricies metus volutpat. Semper wisi et,
                sollicitudin nunc vestibulum, cursus accumsan nunc pede tempus
                mi ipsum, ligula sed. Non condimentum ac dolor sit. Mollis eu
                aliquam, vel mattis mollis massa ut dolor ante, tempus lacinia
                arcu. Urna vestibulum lorem, nulla fermentum, iaculis ut congue
                ac vivamus. Nam libero orci, pulvinar nulla, enim pellentesque
                consectetuer leo, feugiat rhoncus rhoncus vel. Magna sociosqu
                donec, dictum cursus ullamcorper viverra. Ultricies quis orci
                lorem, suspendisse ut vestibulum integer, purus sed lorem
                pulvinar habitasse turpis. +
              </v-card-text>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-spacer />
              <v-btn color="green darken-1" text @click="dialogIntro = false">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- <v-dialog v-model="dialogUpgrade" max-width="40%" scrollable>
          <template v-slot:activator="{ on, attrs }">
            <app-btn
              block
              class="text-none"
              color="secondary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left> mdi-package-up </v-icon>

              Upgrade to Pro
            </app-btn>
          </template>
          <v-card>
            <v-card-title class="headline"> Upgrade to Pro</v-card-title>
            <v-card-text>
              <v-card-text>
                AAAAdolor amet eget, elit nullam. Aliquam leo phasellus aliquam
                curabitur metus a, nulla justo mattis duis interdum vel, mollis
                vitae et id, vestibulum erat ridiculus sit pulvinar justo sed.
                Vehicula convallis, et nulla wisi, amet vestibulum risus, quam
                ac egestas. Et vitae, nulla gravida erat scelerisque nullam nunc
                pellentesque, a dictumst cras augue, purus imperdiet non. Varius
                montes cursus varius vel tortor, nec leo a qui, magni cras,
                velit vel consectetuer lobortis vel. Nibh erat et wisi felis leo
                porttitor, sapien nibh sapien pede mi, sed eget porttitor, eget
                optio quam pellentesque quis lobortis, sollicitudin sed
                vestibulum sollicitudin, lectus parturient nullam, leo orci
                ligula ultrices. At tincidunt enim, suspendisse est sit sem ac.
                Amet tellus molestie est purus magna augue, non etiam et in wisi
                id. Non commodo, metus lorem facilisi lobortis ac velit, montes
                neque sed risus consectetuer fringilla dolor. Quam justo et
                integer aliquam, cursus nulla enim orci, nam cursus adipiscing,
                integer torquent non, fringilla per maecenas. Libero ipsum sed
                tellus purus et. Duis molestie placerat erat donec ut. Dolor
                enim erat massa faucibus ultrices in, ante ultricies orci lacus,
                libero consectetuer mauris magna feugiat neque dapibus, donec
                pretium et. Aptent dui, aliquam et et amet nostra ligula. Augue
                curabitur duis dui volutpat, tempus sed ut pede donec. Interdum
                luctus, lectus nulla aenean elit, id sit magna, vulputate
                ultrices pellentesque vel id fermentum morbi. Tortor et.
                Adipiscing augue lorem cum non lacus, rutrum sodales laoreet
                duis tortor, modi placerat facilisis et malesuada eros ipsum,
                vehicula tempus. Ac vivamus amet non aliquam venenatis lectus,
                sociosqu adipiscing consequat nec arcu odio. Blandit orci nec
                nec, posuere in pretium, enim ut, consectetuer nullam urna,
                risus vel. Nullam odio vehicula massa sed, etiam sociis mauris,
                lacus ullamcorper, libero imperdiet non sodales placerat justo
                vehicula. Nec morbi imperdiet. Fermentum sem libero iaculis
                bibendum et eros, eget maecenas non nunc, ad pellentesque. Ut
                nec diam elementum interdum. Elementum vitae tellus lacus vitae,
                ipsum phasellus, corporis vehicula in ac sed massa vivamus,
                rutrum elit, ultricies metus volutpat. Semper wisi et,
                sollicitudin nunc vestibulum, cursus accumsan nunc pede tempus
                mi ipsum, ligula sed. Non condimentum ac dolor sit. Mollis eu
                aliquam, vel mattis mollis massa ut dolor ante, tempus lacinia
                arcu. Urna vestibulum lorem, nulla fermentum, iaculis ut congue
                ac vivamus. Nam libero orci, pulvinar nulla, enim pellentesque
                consectetuer leo, feugiat rhoncus rhoncus vel. Magna sociosqu
                donec, dictum cursus ullamcorper viverra. Ultricies quis orci
                lorem, suspendisse ut vestibulum integer, purus sed lorem
                pulvinar habitasse turpis. +
              </v-card-text>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-spacer />
              <v-btn color="green darken-1" text @click="dialogUpgrade = false">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </div>
    </template>

    <div class="pt-12" />
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { get, sync } from "vuex-pathify";
import { mapState } from "vuex";
export default {
  name: "Drawer",
  data: () => ({
    dialogIntro: false,
    dialogUpgrade: false,
  }),
  components: {
    DefaultDrawerHeader: () =>
      import(
        /* webpackChunkName: "default-drawer-header" */
        "./widgets/DrawerHeader"
      ),
    DefaultList: () =>
      import(
        /* webpackChunkName: "default-list" */
        "./List"
      ),
  },

  computed: {
    ...get("user", ["dark", "gradient", "image"]),
    ...get("app", [
      "items",
      "version",
      "menuesForStudents",
      "menuesForTeachers",
      "menuesForAccountant",
      "menuesForDiplomaOrganizator",
    ]),
    ...sync("app", ["drawer", "drawerImage", "mini"]),
    ...mapState(["userProfile", "currentUser"]),

    selectedItems: function () {
      if (this.userProfile && this.userProfile.role == "student")
        return this.menuesForStudents;
      else if (this.userProfile && this.userProfile.role == "teacher")
        return this.menuesForTeachers;
      else if (
        this.userProfile &&
        (this.userProfile.role == "teacher" || this.userProfile.role == "admin")
      )
        return this.items;
      else if (this.userProfile && this.userProfile.role == "accountant")
        return this.menuesForAccountant;
      else if (
        this.userProfile &&
        this.userProfile.role == "diplomaorganizator"
      )
        return this.menuesForDiplomaOrganizator;
      //   return this.items.filter(
      //   (a) => a.roleIndex <= this.userProfile.roleIndex
      // );
      //else return this.menuesForStudents;
      //return this.items
    },
  },
};
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important
</style>
